const ITEMS = [
  "Custom Websites",
  "Custom Apps",
  "AI Automations",
  "Bespoke CRMs",
  "Client Portals",
  "Workflow Automation",
  "Built to spec",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="relative py-8 border-y border-white/10 bg-black/40 backdrop-blur-sm overflow-hidden"
      data-testid="marquee"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-heading text-2xl md:text-3xl font-medium text-white/35 px-8">
              {item}
            </span>
            <span className={`h-2 w-2 rounded-full ${["bg-teal","bg-cobalt","bg-violet","bg-magenta"][i % 4]}`} />
          </div>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#050510] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#050510] to-transparent" />
    </div>
  );
};
